import React, {Component} from 'react';
import {Row, Col, Menu} from 'antd';
import TeamSeleted from '../../components/TeamSeleted';
import LeaveTeam from "./LeaveTeam";
import ChangeTeam from "./ChangeTeam";
import ExpulsionList from "./ExpulsionList";

const MenuItem = Menu.Item;

class Staffing extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selMenuKey: "1",
            select_team: {},
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = (data, cb) => {
        if (this._isMounted) {
            this.setState(data, () => {
                if (cb) cb();
            });
        }
    }

    /**
     * 队伍选择
     * @param select_team
     * @param load_index
     */
    teamSelected = (select_team, load_index) => {
        this.setData({select_team, load_index});
    }

    /**
     * Tab按钮点击事件
     **/
    handleTabBtnClick = (e) => {
        const key = e.key, {selMenuKey} = this.state;
        if (selMenuKey !== key) {
            this.setData({selMenuKey: key});
        }
    }

    render() {
        const {selMenuKey, select_team} = this.state,
            team_id = select_team.team_id || "",
            teamno = select_team.teamno || "";
        let content_node = null, itemNode = null;
        if (team_id && teamno) {
            switch (selMenuKey) {
                case "2":
                    content_node = (<LeaveTeam teamno={teamno}/>);
                    break;
                case "3":
                    content_node = (<ExpulsionList teamno={teamno}/>);
                    break;
            }
        }
        if (selMenuKey === "1") {
            itemNode = (<ChangeTeam team_id={team_id}/>);
        } else {
            itemNode = (
                <Row className="content">
                    <Col span={5} className="team-select">
                        <TeamSeleted handleData={this.teamSelected} border/>
                    </Col>
                    <Col span={18} offset={1} className="team-table">
                        {content_node}
                    </Col>
                </Row>
            );
        }
        return (
            <div className="rank-staffing team-editor">
                <Row className="top-title">
                    <Col span={6}>人员调配</Col>
                    <Col span={18} className="tab-btns">
                        <Menu
                            onSelect={this.handleTabBtnClick}
                            selectedKeys={[selMenuKey]}
                            mode="horizontal"
                        >
                            <MenuItem key="3" className='no-select'><span>清退名单</span></MenuItem>
                            <MenuItem key="2" className='no-select'><span>离队名单</span></MenuItem>
                            <MenuItem key="1" className='no-select'><span>转队</span></MenuItem>
                        </Menu>
                    </Col>
                </Row>
                {itemNode}
            </div>
        );
    }
}

export default Staffing ;



// WEBPACK FOOTER //
// ./src/routes/ranks/Staffing.jsx